<template>
  <v-simple-table dense>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left"></th>
          <th class="text-left">
            Liten vannføring
          </th>
          <th class="text-left">
            Normalområde
          </th>
          <th class="text-left">
            Stor vannføring
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="no-table-hover">
          <td>Forhold for VST registrering</td>
          <td>{{ tidsserieAttributes.VSTFORHOLDLAV }}</td>
          <td>{{ tidsserieAttributes.VSTFORHOLDNORMAL }}</td>
          <td>{{ tidsserieAttributes.VSTFORHOLDFLOM }}</td>
        </tr>
        <tr class="no-table-hover">
          <td>Forhold for VF måling</td>
          <td>{{ tidsserieAttributes.VFFORHOLDLAV }}</td>
          <td>{{ tidsserieAttributes.VFFORHOLDNORMAL }}</td>
          <td>{{ tidsserieAttributes.VFFORHOLDFLOM }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: "TableRowForhold",
  props: {
    tidsserieAttributes: Object,
  },
};
</script>
